import type { StateCreator } from 'zustand';
interface RatioStore {
  activeProjectId: number | null;
  selectedAspectRatio: string;
  selectedAspectRatios: string[];
  aspectRatiosByProject?: Record<number, string[]>;
}
/** Scope format overrides to a task. Draft materialization supplies its selection explicitly. */
export function withImageRatios<T extends RatioStore>(creator: StateCreator<T>): StateCreator<T> {
  return (set, get, api) => {
    const scopedSet: typeof set = (update, replace) => {
      const previous = get();
      const next = typeof update === 'function' ? update(previous) : update;
      if (previous && Object.hasOwn(next, 'activeProjectId') && (next.activeProjectId !== previous.activeProjectId || next.activeProjectId === null)) {
        const saved = { ...previous.aspectRatiosByProject };
        if (previous.activeProjectId !== null) saved[previous.activeProjectId] = [...previous.selectedAspectRatios];
        const ratios = next.selectedAspectRatios ?? (next.activeProjectId == null ? ['auto'] : saved[next.activeProjectId] ?? ['auto']);
        if(next.activeProjectId != null) saved[next.activeProjectId] = [...ratios];
        set({ ...next, selectedAspectRatios: ratios, selectedAspectRatio: ratios[0], aspectRatiosByProject: saved } as T, replace as false);
      } else if(previous?.activeProjectId != null && next.selectedAspectRatios) {
        set({...next,aspectRatiosByProject:{...previous.aspectRatiosByProject,...next.aspectRatiosByProject,[previous.activeProjectId]:[...next.selectedAspectRatios]}} as T,replace as false);
      } else set(next as T, replace as false);
    };
    api.setState = scopedSet;
    return creator(scopedSet, get, api);
  };
}
